// extracted by mini-css-extract-plugin
module.exports = {"cardArea":"cardDisplay_cardArea__1Cij2","cardLogo":"cardDisplay_cardLogo__1LFk6","nameNumber":"cardDisplay_nameNumber__DyQ-d"};